mutation TravelAuthorizationAccountingStamper(
  $input: TravelAuthorizationAccountingStamperInput!
) {
  travelAuthorizationAccountingStamper(input: $input) {
    travelAuthorization {
      id
      stampedEntityDocumentId
      _accountingStampDate
      _accountingStampUserId
      _accountingStampUserName
      _accountingStampTransactionReference
    }
  }
}
